var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPic1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 174,
    viewBox: "0 0 312 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 174,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.894 121.022H85.1234V43.8948C85.1234 39.7096 88.3964 36.3333 92.4157 36.3333H207.601C211.637 36.3333 214.894 39.7272 214.894 43.8948V121.022Z",
    fill: "#A0BFF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3889 128.83V134.774C75.3889 138.589 78.3737 141.667 82.0368 141.667H217.963C221.643 141.667 224.611 138.572 224.611 134.774V128.83H75.3889Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.894 47.9042H85.1234V43.8948C85.1234 39.7096 88.3964 36.3333 92.4157 36.3333H207.601C211.637 36.3333 214.894 39.7272 214.894 43.8948V47.9042Z",
    fill: "#276EF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.911 121.022H85.1234V128.83H214.911V121.022Z",
    fill: "#276EF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.032 134.422H137.985C135.017 134.422 132.592 131.925 132.592 128.83H167.408C167.408 131.925 165 134.422 162.032 134.422Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201 48H96V109H201V48Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.589 76.2412C124.019 76.2412 125.179 75.0819 125.179 73.6519C125.179 72.2218 124.019 71.0626 122.589 71.0626C121.159 71.0626 120 72.2218 120 73.6519C120 75.0819 121.159 76.2412 122.589 76.2412Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.519 71.929H178.71V75.3825H132.519V71.929Z",
    fill: "#A0BFF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.589 86.1822C124.019 86.1822 125.179 85.0229 125.179 83.5929C125.179 82.1629 124.019 81.0036 122.589 81.0036C121.159 81.0036 120 82.1629 120 83.5929C120 85.0229 121.159 86.1822 122.589 86.1822Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.519 81.8579H178.71V85.3115H132.519V81.8579Z",
    fill: "#A0BFF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.589 96.0771C124.019 96.0771 125.179 94.9178 125.179 93.4878C125.179 92.0577 124.019 90.8985 122.589 90.8985C121.159 90.8985 120 92.0577 120 93.4878C120 94.9178 121.159 96.0771 122.589 96.0771Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.519 91.7869H178.71V95.2404H132.519V91.7869Z",
    fill: "#A0BFF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120 62H178.71V65.4536H120V62Z",
    fill: "#A0BFF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic1);
export default __webpack_public_path__ + "static/media/pic1.f0be9f6e7702b010d58e57dc3bab6918.svg";
export { ForwardRef as ReactComponent };